import React from 'react';
import { styled } from 'baseui';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { LabelMedium } from 'baseui/typography';
import { TimeSeriesDataPoint } from '../../../utils/dashboardUtils';

const ChartContainer = styled('div', {
  backgroundColor: '#fff',
  borderRadius: '8px',
  boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
  padding: '20px',
  minHeight: '450px',
  display: 'flex',
  flexDirection: 'column',
});

const ChartHeader = styled('div', {
  marginBottom: '16px',
});

interface TrendChartProps {
  data: TimeSeriesDataPoint[];
}

export const TrendChart: React.FC<TrendChartProps> = ({ data }) => {
  return (
    <ChartContainer>
      <ChartHeader>
        <LabelMedium margin={0}>Access Trends</LabelMedium>
      </ChartHeader>
      <ResponsiveContainer width="100%" height={350}>
        <LineChart data={data} margin={{ top: 5, right: 30, left: 20, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <XAxis dataKey="date" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Line
            type="monotone"
            dataKey="total"
            stroke="#8884d8"
            strokeWidth={2}
            dot={{ r: 4 }}
            activeDot={{ r: 6 }}
            name="Total"
          />
          <Line
            type="monotone"
            dataKey="in"
            stroke="#82ca9d"
            strokeWidth={2}
            dot={{ r: 4 }}
            activeDot={{ r: 6 }}
            name="In"
          />
          <Line
            type="monotone"
            dataKey="pending"
            stroke="#ffc658"
            strokeWidth={2}
            dot={{ r: 4 }}
            activeDot={{ r: 6 }}
            name="Pending"
          />
          <Line
            type="monotone"
            dataKey="out"
            stroke="#607D8B"
            strokeWidth={2}
            dot={{ r: 4 }}
            activeDot={{ r: 6 }}
            name="Out"
          />
        </LineChart>
      </ResponsiveContainer>
    </ChartContainer>
  );
};
